import { Skeleton } from '@components/atoms/Skeleton/Skeleton';
import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export interface CardTextSkeletonProps extends PropsWithClassProps {
  /** Number of title lines below the meta line. */
  titleLines?: number;
  /** Reserve the round action button (e.g. FavoriteButton) on the right. */
  withAction?: boolean;
}

/** Loading placeholder for a card's text area: meta line, title lines, optional action. */
export const CardTextSkeleton = ({ titleLines = 2, withAction = false, classProps }: CardTextSkeletonProps) => (
  <div className={twMerge('flex w-full justify-between gap-3 p-2', classProps?.root)}>
    <div className="mt-1 flex flex-1 flex-col gap-2">
      <Skeleton classProps={{ root: 'h-3.5 w-24 bg-foreground/15' }} />
      {Array.from({ length: titleLines }, (_, index) => (
        <Skeleton
          key={index}
          classProps={{
            root: twMerge('h-4 bg-foreground/15', index === titleLines - 1 ? 'w-3/5' : 'w-4/5'),
          }}
        />
      ))}
    </div>
    {withAction && <Skeleton classProps={{ root: 'mt-2 size-8 flex-none rounded-full bg-foreground/15' }} />}
  </div>
);
